import { render, staticRenderFns } from "./GirthData.vue?vue&type=template&id=574d5c34&scoped=true&"
import script from "./GirthData.vue?vue&type=script&lang=js&"
export * from "./GirthData.vue?vue&type=script&lang=js&"
import style0 from "./GirthData.vue?vue&type=style&index=0&id=574d5c34&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574d5c34",
  null
  
)

export default component.exports